import { z } from 'zod';
import { Voltage } from './Voltage';

const units = Voltage.units;

const validator = z.preprocess((value: any) => {
    return value
        ? {
              value: value.value || null,
              unit: 'V',
          }
        : value;
}, Voltage.validators.value);

export const IsolationVoltage = {
    validator,
    units,
};
